<template>
  <div>
    <div>
      <b-navbar toggleable="lg" type="light" class="shadow-sm">
        <b-navbar-brand>
          <router-link :to="{
        path: '/',
       
      }">
            <h1 class="title is-3 is-flex-mobile"></h1>
          </router-link>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <menu-component></menu-component>

          <search-component></search-component>

          <menu-left-component></menu-left-component>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import Menu from "../menu/Menu";
import MenuLeft from "../menu/MenuLeft";
import Search from "../search/Search";

export default {
  name: "header-component",

  data() {
    return {
      linkedinTooltip: "Siga-nos no Linkedin",
      facebookTooltip: "Siga-nos no Facebook",
      twitterTooltip: "Siga-nos no Twitter",
      instagramTooltip: "Siga-nos no Instagram",
      isCheckoutActive: false,
      isMenuOpen: false,
    };
  },

  computed: {
  
  },

  components: {
    "search-component": Search,
    "menu-component": Menu,
    "menu-left-component": MenuLeft,
  },

  methods: {
    showCheckoutModal() {
      this.$store.commit("showCheckoutModal", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  background: url("../../../public/img/logo.png") no-repeat;
  background-position: 50% 50%;
  background-size: 90px;
  width: 90px;
  height: 35px;
}
.shopping-cart {
  cursor: pointer;
}
a {
  color: grey;
}
</style>
